import { styled } from '@mui/material/styles';
import { Box, IconButton, ListItemSecondaryAction } from '@mui/material';
import { DragIndicator } from '@mui/icons-material';
import { StyledDragIndicatorProps } from './ListItemSecondaryAction.types';

export const StyledSecondaryAction = styled(ListItemSecondaryAction)(() => ({
  right: 16
}));

export const ControlsWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 4
}));

export const StyledIconButton = styled(IconButton)(() => ({
  padding: 4
}));

export const StyledDragIndicator = styled(DragIndicator, {
  shouldForwardProp: prop => !['isDragging', 'isVisible', 'isOkko', 'isMobile'].includes(prop as string)
})<StyledDragIndicatorProps>(({ isDragging, isVisible, isOkko, isMobile, theme }) => ({
  color: isDragging
    ? 'rgb(132, 189, 0)'
    : isVisible && !isOkko
      ? theme.palette.text.primary
      : theme.palette.text.disabled,
  cursor: isVisible && !isOkko ? 'grab' : 'default',
  fontSize: isDragging ? (isMobile ? '1.5rem' : '1.2rem') : isMobile ? '1.25rem' : '1rem',
  transition: 'all 0.2s ease'
}));
